import { Stack } from "@mui/material";
import { cloneElement, type ReactElement, useState } from "react";

import type { AccordionCardProps } from "./AccordionCard";

interface AccordionGroupProps {
  children: Array<ReactElement<AccordionCardProps>> | ReactElement<AccordionCardProps>;
  defaultExpandedIndex?: number;
}

export function AccordionGroup(props: AccordionGroupProps) {
  const { children, defaultExpandedIndex } = props;
  const [expandedCardId, setExpandedCardId] = useState<string | undefined>(
    defaultExpandedIndex === undefined ? undefined : `filter-card-${defaultExpandedIndex}`
  );

  return (
    <Stack spacing={4}>
      {Array.isArray(children)
        ? children.map((child, index) => {
            const cardId = `filter-card-${index}`;
            const isExpanded = expandedCardId === cardId;

            return cloneElement(child, {
              key: cardId,
              isExpanded,
              onToggle: () => {
                setExpandedCardId(isExpanded ? undefined : cardId);
              },
            });
          })
        : children}
    </Stack>
  );
}
